module.exports = __webpack_public_path__ + "media/images/logo_sc23-4b81eb39c228b4216162679e748bdf64.png";